// userSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { useInsertData } from "../../hooks/useInsertData";
import { useGetData } from "../../hooks/useGetData";
import { useUpdateData } from "../../hooks/useUpdateDate";
import useDeleteData from "../../hooks/useDeleteData";

export const getAllUsers = createAsyncThunk(
  "user/getAllUsers",
  async ({ page, status = false }, { rejectWithValue }) => {
    try {
      const res = await useGetData(
        `users?page=${page}${status ? "&sort=status" : ""}`
      );
      console.log(res);
      return res;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  }
);

export const getUserById = createAsyncThunk(
  "user/getUserById",
  async (id, { rejectWithValue }) => {
    try {
      const res = await useGetData(`users/${id}`);
      return res.data;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  }
);

export const updateStatusUser = createAsyncThunk(
  "user/updateStatusUser",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const res = await useUpdateData(`users/status/${id}`, data);
      return res.data;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  }
);

export const updateInfoUser = createAsyncThunk(
  "user/updateInfoUser",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const res = await useUpdateData(`users/${id}`, data);
      return res.data;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  }
);

export const updateRole = createAsyncThunk(
  "user/updateRole",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const res = await useUpdateData(`users/role/${id}`, data);
      return res.data;
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  }
);

export const deleteUser = createAsyncThunk(
  "user/deleteUser",
  async (id, { rejectWithValue }) => {
    try {
      const res = await useDeleteData(`users/force/${id}`);
      return { id, res };
    } catch (err) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err.message);
    }
  }
);

const initialState = {
  allUsers: null,
  detailsUser: null,
  updatedUser: null,
  statusUser: null,
  status: "idle",
  error: null,
  pagination: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllUsers.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getAllUsers.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allUsers = action.payload?.data;
        state.pagination = action.payload?.pagination;
      })
      .addCase(getAllUsers.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(getUserById.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getUserById.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.detailsUser = action.payload;
      })
      .addCase(getUserById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(updateStatusUser.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateStatusUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.statusUser = action.payload;
      })
      .addCase(updateStatusUser.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(deleteUser.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(action.payload);
        state.allUsers = state.allUsers.filter(
          (user) => user.id !== action.payload.id
        );
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(updateInfoUser.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateInfoUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.updatedUser = action.payload.data;
      })
      .addCase(updateInfoUser.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default userSlice.reducer;
